export default {"src":"/_next/static/media/facebook.64618758.svg","height":20,"width":12,"blurWidth":0,"blurHeight":0};